import { EventEmitter, Injectable, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '../languages/language.service';
import { FilterTableService } from '../offers/filter-table.service';

@Injectable({
  providedIn: 'root',
})
export class NavBarService implements OnInit {
  homeSelected: boolean;

  estatesSelected: boolean;
  salesSelected: boolean;
  rentsSelected: boolean;
  createOfferSelected: boolean;
  subscriptionSelected: boolean;

  newsSelected: boolean;
  servicesSelected: boolean;

  helpSelected: boolean;
  regionAndCountrySelected: boolean;
  bulgariaSelected: boolean;
  varnaSelected: boolean;
  regionsSelected: boolean;

  notaryCalculatorSelected: boolean;
  howToSellSelected: boolean;

  aboutSelected: boolean;
  historySelected: boolean;
  principlesSelected: boolean;
  teamSelected: boolean;

  policySelected: boolean;

  contactsSelected: boolean;
  private language: string;

  constructor(
    private router: Router,
    private languageService: LanguageService,
    private fts: FilterTableService
  ) {
    this.deselectAll();
  }

  ngOnInit(): void {
    this.languageService.currentLanguageKey.subscribe(
      (lg) => (this.language = lg)
    );
  }

  homeClicked() {
    this.languageService.currentLanguageKey.subscribe(
      (lg) => (this.language = lg)
    );
    if (this.router.url.includes('home')) {
      this.router.navigateByUrl('/bg/about/history');
    }
    this.router.navigate([this.language, 'home']);
  }

  estatesClicked() {
    this.router.navigate([this.language, 'estates']).then(() => {
      this.fts.currentSelection = '';
      this.fts.resetOnRouteChange();
    });
  }

  salesClicked() {
    this.router.navigate([this.language, 'estates', 'sales', 1]).then(() => {
      this.fts.currentSelection = '';
      this.fts.resetOnRouteChange();
    });
  }

  rentsClicked() {
    this.router.navigate([this.language, 'estates', 'rents', 1]).then(() => {
      this.fts.currentSelection = '';
      this.fts.resetOnRouteChange();
    });
  }

  createOfferClicked() {
    this.router.navigate([this.language, 'estates', 'create-offer']);
  }

  subscriptionClicked() {
    this.router.navigate([this.language, 'estates', 'subscription']);
  }

  newsClicked() {
    this.router.navigate([this.language, 'news']);
  }

  servicesClicked() {
    this.router.navigate([this.language, 'services']);
  }

  helpClicked() {
    this.router.navigate([this.language, 'help', 'more-info']);
  }

  countryAndRegionClicked() {
    this.router.navigate([this.language, 'help', 'more-info']);
  }

  bulgariaClicked() {
    this.router.navigate([this.language, 'help', 'more-info', 'bulgaria']);
  }

  varnaClicked() {
    this.router.navigate([this.language, 'help', 'more-info', 'varna']);
  }

  regionsClicked() {
    this.router.navigate([this.language, 'help', 'more-info', 'regions']);
  }

  notaryCalculatorClicked() {
    this.router.navigate([this.language, 'help', 'notary-calculator']);
  }

  howToSellClicked() {
    this.router.navigate([this.language, 'help', 'selling-your-estate']);
  }

  policyClicked() {
    this.router.navigate([this.language, 'help', 'policy']);
  }

  aboutClicked() {
    this.router.navigate([this.language, 'about', 'history']);
  }

  historyClicked() {
    this.router.navigate([this.language, 'about', 'history']);
  }

  principlesClicked() {
    this.router.navigate([this.language, 'about', 'principles']);
  }

  teamClicked() {
    this.router.navigate([this.language, 'about', 'our-team']);
  }

  contactsClicked() {
    this.router.navigate([this.language, 'contacts']);
  }

  deselectAll() {
    this.homeSelected = false;

    this.estatesSelected = false;
    this.salesSelected = false;
    this.rentsSelected = false;
    this.createOfferSelected = false;
    this.subscriptionSelected = false;

    this.newsSelected = false;
    this.servicesSelected = false;

    this.helpSelected = false;
    this.regionAndCountrySelected = false;
    this.bulgariaSelected = false;

    this.varnaSelected = false;
    this.regionsSelected = false;
    this.notaryCalculatorSelected = false;
    this.howToSellSelected = false;

    this.aboutSelected = false;
    this.historySelected = false;
    this.principlesSelected = false;
    this.teamSelected = false;
    this.policySelected = false;

    this.contactsSelected = false;
  }
}
